import { publicUrl } from "../publicUrl";

import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height }: SvgIconProps) => (
    <img src={publicUrl(`/img/svg/${src}`)} alt="" width={width} height={height} />
);
